// シーン写真の拡大（トップの組写真・ポラロイド・商品ページの写真の列）。[data-zoom] に大きい画像の URL。ライブラリなしの手書き。
// 動きの設計:
//   開く  … 押した写真が額から抜けて（元の枠は空になる）、位置・大きさ・切り抜き・傾きがつながったまま全画面へ（FLIP）。
//           写真はばねで 0.76 秒（わずかに行き過ぎて落ち着く）、壁色を少し暗くした幕が裾を波打たせて上から 0.62 秒で降りる。
//           前後の写真は 0.2 秒遅れて横から、数字と説明は 0.3 秒遅れて 0.26 秒で速く出る。
//   送る  … 指に 1:1 で吸い付き、離した速さを引き継いだばねで次の写真へ。端はゴムのように抵抗。前後の写真の端が見える。
//           大きい画像は開いた写真と、送る直前（ドラッグを始めた向き・矢印に乗せた時・送る時）にだけ読む。
//   閉じる … 今の写真の額へ縮んで戻り、幕は上へ巻き上がる。下へ払うと写真が指について傾き、幕が薄れて閉じる。
//   動きを減らす設定では、すべてフェードだけ。← → Esc、Tab は拡大の中を回る、閉じたら押した写真へフォーカスを戻す。
(() => {
  const els = [...document.querySelectorAll('[data-zoom]')];
  if (!els.length) return;
  const ja = document.documentElement.lang === 'ja';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const imgOf = el => (el.tagName === 'IMG' ? el : el.querySelector('img'));

  // 同じ写真は 1 枚にまとめる（トップのポラロイドと「This room is real.」は同じ写真）。ポラロイドは並びの最後に回す
  const order = els.filter(el => !el.classList.contains('intro__photo')).concat(els.filter(el => el.classList.contains('intro__photo')));
  const urls = [], srcs = [];
  order.forEach(el => {
    let k = urls.indexOf(el.dataset.zoom);
    if (k < 0) { k = urls.push(el.dataset.zoom) - 1; srcs[k] = []; }
    srcs[k].push(el); el._zk = k;
  });
  const N = urls.length;
  const ratioOf = k => {
    for (const el of srcs[k]) { const im = imgOf(el); if (im?.naturalWidth) return im.naturalWidth / im.naturalHeight; }
    const im = imgOf(srcs[k][0]); return (+im?.getAttribute('width') || 1) / (+im?.getAttribute('height') || 1);
  };
  const altOf = k => srcs[k].map(el => imgOf(el)?.alt || '').sort((a, b) => b.length - a.length)[0] || '';

  // ばねの緩急を linear() に（ζ=0.8: 1.5% だけ行き過ぎて落ち着く）。古いブラウザは cubic-bezier
  const spring = z => {
    if (!CSS.supports?.('animation-timing-function', 'linear(0, 1)')) return 'cubic-bezier(.2, .75, .15, 1)';
    const w = 6.2 / z, wd = w * Math.sqrt(1 - z * z), pts = [];
    for (let n = 0; n <= 48; n++) { const t = n / 48; pts.push(n === 48 ? 1 : +(1 - Math.exp(-z * w * t) * (Math.cos(wd * t) + (z * w / wd) * Math.sin(wd * t))).toFixed(4)); }
    return `linear(${pts.join(', ')})`;
  };
  const EASE_PHOTO = spring(0.8), EASE_SOFT = 'cubic-bezier(.3, .7, .4, 1)', EASE_BACK = 'cubic-bezier(.32, .72, 0, 1)', EASE_FAST = 'cubic-bezier(.2, .8, .3, 1)';
  const ID = 'translate(0px, 0px) rotate(0rad) scale(1)';
  const HEM = 26;

  const st = document.createElement('style');
  st.textContent = `
    .zm { position: fixed; inset: 0; z-index: 1000; overflow: hidden; touch-action: none; -webkit-user-select: none; user-select: none; -webkit-tap-highlight-color: transparent; --zc: #cdd8db; --zi: var(--ink, #303235); --zi2: var(--ink2, #5d5a52); }
    .zm[hidden] { display: none !important; }
    .zm__curtain { position: absolute; left: 0; right: 0; top: 0; height: 100%; background: var(--zc); will-change: transform, opacity; }
    .zm__curtain::after { content: ""; position: absolute; left: 0; right: 0; top: calc(100% - 1px); height: ${HEM}px; background: var(--zc);
      -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 26'%3E%3Cpath d='M0 0h120v9c-15 0-15 14-30 14S75 9 60 9 45 23 30 23 15 9 0 9z'/%3E%3C/svg%3E") 0 0 / 120px ${HEM}px repeat-x;
              mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 26'%3E%3Cpath d='M0 0h120v9c-15 0-15 14-30 14S75 9 60 9 45 23 30 23 15 9 0 9z'/%3E%3C/svg%3E") 0 0 / 120px ${HEM}px repeat-x; }
    .zm__track { position: absolute; left: 0; top: 0; will-change: transform; }
    .zm__slide { position: absolute; left: 0; top: 0; transform-origin: 50% 50%; }
    .zm__fig { position: absolute; inset: 0; margin: 0; background: var(--wall, #e2eaec); transform-origin: 50% 50%; will-change: transform; }
    .zm__fig img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; -webkit-user-drag: none; pointer-events: none; }
    .zm__hi { opacity: 0; }
    .zm__ui { position: absolute; inset: 0; pointer-events: none; color: var(--zi); }
    .zm__ui > * { pointer-events: auto; }
    .zm__btn { position: absolute; display: grid; place-items: center; width: 48px; height: 48px; padding: 0; border: 1.6px solid var(--zi); border-radius: 999px; background: var(--floor, #fbf6db); color: var(--zi); cursor: pointer; transition: transform .25s cubic-bezier(.3, 1.4, .5, 1), opacity .2s; }
    .zm__btn svg { width: 22px; height: 22px; fill: none; stroke: currentColor; stroke-width: 2.2; stroke-linecap: round; stroke-linejoin: round; }
    @media (hover: hover) { .zm__btn:hover { transform: scale(1.08) rotate(-4deg); } }
    .zm__btn:active { transform: scale(.94); }
    .zm__btn:focus-visible { outline: 2px solid var(--zi); outline-offset: 3px; }
    .zm__btn:disabled { opacity: 0; pointer-events: none; }
    .zm__close { top: 16px; right: 18px; }
    .zm__prev { left: 20px; top: 50%; margin-top: -24px; }
    .zm__next { right: 20px; top: 50%; margin-top: -24px; }
    .zm__count { position: absolute; top: 28px; left: 26px; margin: 0; font: 400 15px/1 var(--display, Georgia, serif); color: var(--zi2); letter-spacing: .04em; font-variant-numeric: tabular-nums; }
    .zm__count b { display: inline-block; font-weight: inherit; color: var(--zi); }
    .zm__cap { position: absolute; left: 50%; bottom: 30px; width: max-content; max-width: min(640px, calc(100% - 48px)); margin: 0; translate: -50% 0; text-align: center; font: 400 13px/1.55 var(--ui, system-ui, sans-serif); color: var(--zi2); }
    .zm__cap[hidden] { display: none; }
    html.is-zoom, html.is-zoom body { overflow: hidden; }
    html.is-zoom { padding-right: var(--zm-sb, 0px); }
    @media (max-width: 700px) {
      .zm__prev, .zm__next { display: none; }
      .zm__close { top: 12px; right: 12px; width: 44px; height: 44px; }
      .zm__count { top: 26px; left: 18px; font-size: 14px; }
      .zm__cap { bottom: 22px; font-size: 12px; max-width: calc(100% - 32px); }
    }
  `;
  document.head.append(st);

  const svg = d => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg>`;
  const box = document.createElement('div');
  box.className = 'zm'; box.hidden = true;
  box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', ja ? '写真' : 'Photos');
  box.innerHTML = `<div class="zm__curtain"></div><div class="zm__track"></div>
    <div class="zm__ui">
      <p class="zm__count" aria-live="polite"></p>
      <button type="button" class="zm__btn zm__close" aria-label="${ja ? '閉じる' : 'Close'}">${svg('M6.5 6.8c3.6 3.2 7.4 7 11 10.6M17.3 6.6c-3.4 3.5-7.3 7.4-10.8 10.9')}</button>
      <button type="button" class="zm__btn zm__prev" aria-label="${ja ? '前の写真' : 'Previous photo'}">${svg('M19 12.2c-4.6-.1-9.2 0-13.6.1M10.6 6.6c-1.9 2-3.6 3.8-5.4 5.6 1.8 1.8 3.6 3.6 5.5 5.4')}</button>
      <button type="button" class="zm__btn zm__next" aria-label="${ja ? '次の写真' : 'Next photo'}">${svg('M5 11.8c4.6.1 9.2 0 13.6-.1M13.4 6.4c1.9 2 3.6 3.8 5.4 5.6-1.8 1.8-3.6 3.6-5.5 5.4')}</button>
      <p class="zm__cap"></p>
    </div>`;
  document.body.append(box);
  const curtain = box.querySelector('.zm__curtain'), track = box.querySelector('.zm__track');
  const count = box.querySelector('.zm__count'), cap = box.querySelector('.zm__cap');
  const bClose = box.querySelector('.zm__close'), bPrev = box.querySelector('.zm__prev'), bNext = box.querySelector('.zm__next');
  const S = urls.map(() => {
    const slide = document.createElement('div'); slide.className = 'zm__slide';
    slide.innerHTML = '<figure class="zm__fig"><img class="zm__lo" alt="" draggable="false"><img class="zm__hi" alt="" draggable="false"></figure>';
    track.append(slide);
    return { slide, fig: slide.firstChild, lo: slide.querySelector('.zm__lo'), hi: slide.querySelector('.zm__hi'), ar: 1, w: 0, h: 0, full: false };
  });

  // 並べ方: 写真は余白の中に収め、隣の写真は「間をあける」か「端が peek だけ見える」の遠いほうに置く
  let W = 0, H = 0, top = 0, R = 10, x = [], pos = 0, i = 0, state = 'closed';
  function layout() {
    W = innerWidth; H = innerHeight;
    const sp = W <= 700, peek = sp ? 16 : 72, gap = sp ? 10 : 36, bot = sp ? 76 : 88;
    top = sp ? 72 : 80; R = sp ? 8 : 10;
    const bw = W - 2 * (peek + gap), bh = H - top - bot;
    S.forEach((s, k) => {
      s.ar = ratioOf(k); s.w = Math.min(bw, bh * s.ar); s.h = s.w / s.ar;
      s.slide.style.width = s.w + 'px'; s.slide.style.height = s.h + 'px';
      s.fig.style.clipPath = `inset(0px 0px 0px 0px round ${R}px)`;
      s.y = top + (bh - s.h) / 2;
    });
    x = [0];
    for (let k = 1; k < N; k++) x[k] = x[k - 1] + Math.max(S[k - 1].w / 2 + gap + S[k].w / 2, W / 2 - peek + S[k].w / 2);
  }
  function render() {
    track.style.transform = `translate3d(${-pos}px, 0, 0)`;
    S.forEach((s, k) => {
      const d = Math.abs(x[k] - pos), vis = d - s.w / 2 < W / 2 + 40;
      s.slide.style.visibility = vis ? '' : 'hidden';
      if (!vis) return;
      prime(k);
      const t = Math.min(d / (W / 2), 1);
      s.slide.style.transform = `translate3d(${W / 2 + x[k] - s.w / 2}px, ${s.y}px, 0) scale(${1 - t * 0.08})`;
      s.slide.style.opacity = 1 - t * 0.45;
    });
  }
  // 画像: 見えている写真は手元のサムネイル（読み込み済み）で即座に出し、大きい画像は必要な時だけ読んで重ねる
  function prime(k) {
    const s = S[k]; if (!s || s.lo.getAttribute('src')) return;
    const im = srcs[k].map(imgOf).find(m => m?.complete && m.naturalWidth) || imgOf(srcs[k][0]);
    s.lo.src = im?.currentSrc || im?.src || urls[k];
  }
  function full(k) {
    const s = S[k]; if (!s || s.full) return;
    s.full = true;
    const im = new Image(); im.decoding = 'async'; im.src = urls[k];
    im.decode().then(() => {
      s.hi.src = urls[k];
      const ar = im.naturalWidth / im.naturalHeight;
      if (Math.abs(ar - s.ar) / s.ar > 0.01 && state === 'open') { layout(); pos = x[i]; render(); }
      if (reduce.matches || box.hidden) s.hi.style.opacity = 1;
      else s.hi.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 280, easing: 'ease-out', fill: 'forwards' });
    }).catch(() => { s.full = false; });
  }

  function ui(dir) {
    count.innerHTML = `<b>${i + 1}</b> / ${N}`;
    const a = altOf(i);
    cap.textContent = a; cap.hidden = !a;
    S.forEach((s, k) => { s.hi.alt = k === i ? a : ''; });
    bPrev.disabled = i === 0; bNext.disabled = i === N - 1;
    if (dir && !reduce.matches) {
      count.firstChild.animate([{ opacity: 0, transform: `translateY(${dir * 7}px)` }, { opacity: 1, transform: 'none' }], { duration: 240, easing: EASE_FAST });
      if (a) cap.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 260, delay: 120, easing: EASE_FAST, fill: 'backwards' });
    }
  }

  // 送りのばね（指の速さを引き継ぐ）。単位は px と 秒
  let raf = 0;
  function stopSpring() { cancelAnimationFrame(raf); raf = 0; }
  function springTo(target, v = 0) {
    stopSpring();
    const k = reduce.matches ? 900 : 210, c = 2 * Math.sqrt(k) * (reduce.matches ? 1 : 0.9);
    let last = performance.now();
    const step = now => {
      let dt = Math.min((now - last) / 1000, 0.05); last = now;
      while (dt > 0) { const h = Math.min(dt, 1 / 240); v += (-k * (pos - target) - c * v) * h; pos += v * h; dt -= h; }
      if (Math.abs(pos - target) < 0.3 && Math.abs(v) < 6) { pos = target; render(); raf = 0; return; }
      render(); raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
  }
  function go(k, v = 0) {
    if (state !== 'open') return;
    if (k < 0 || k >= N) { springTo(x[i], (k < 0 ? -1 : 1) * 900); return; } // 端: 少しはみ出して戻る
    const dir = Math.sign(k - i);
    i = k; full(i);
    springTo(x[i], v);
    if (dir) ui(dir);
  }

  // 押した写真の「見えている枠」を測り、拡大の写真をそこへ重ねる変形（中心基準: 移動・回転・拡縮）と切り抜きを求める
  function scroller(el) {
    for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      const ox = getComputedStyle(p).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && p.scrollWidth > p.clientWidth) return p;
    }
  }
  function geom(el, k) {
    const im = imgOf(el), frame = im && im !== el && getComputedStyle(el).overflow === 'hidden' ? el : im;
    if (!frame) return null;
    const r = frame.getBoundingClientRect();
    if (!r.width || r.bottom < 0 || r.top > innerHeight || r.right < 0 || r.left > innerWidth) return null;
    const m = new DOMMatrixReadOnly(getComputedStyle(el).transform === 'none' ? undefined : getComputedStyle(el).transform);
    const ang = Math.atan2(m.b, m.a), sc = Math.hypot(m.a, m.b) || 1;
    const fs = getComputedStyle(frame), bw = parseFloat(fs.borderLeftWidth) || 0;
    const tw = frame.clientWidth * sc, th = frame.clientHeight * sc;
    const s = S[k], fw = s.w, fh = s.h, ta = tw / th;
    let vw = s.ar > ta ? fh * ta : fw, vh = s.ar > ta ? fh : fw / ta;
    const op = getComputedStyle(im).objectPosition.split(' ').map(v => (v.endsWith('%') ? parseFloat(v) / 100 : 0.5));
    let L = (fw - vw) * op[0], T = (fh - vh) * (op[1] ?? 0.5);
    if (frame !== im) { // 枠の中で写真だけ拡大されている（ホバー・寄り）分
      const mi = getComputedStyle(im).transform, z = mi === 'none' ? 1 : Math.hypot(new DOMMatrixReadOnly(mi).a, new DOMMatrixReadOnly(mi).b);
      L += (vw - vw / z) / 2; T += (vh - vh / z) / 2; vw /= z; vh /= z;
    }
    const Rr = fw - vw - L, B = fh - vh - T, scale = tw / vw;
    const ox = (L - Rr) / 2, oy = (T - B) / 2;
    const rx = scale * (Math.cos(ang) * ox - Math.sin(ang) * oy), ry = scale * (Math.sin(ang) * ox + Math.cos(ang) * oy);
    const cx = W / 2 + x[k] - pos, cy = s.y + fh / 2;
    const tx = r.left + r.width / 2 - cx - rx, ty = r.top + r.height / 2 - cy - ry;
    const rad = Math.max(0, (parseFloat(fs.borderTopLeftRadius) || 0) - bw) / scale;
    return {
      img: im,
      t: `translate(${tx}px, ${ty}px) rotate(${ang}rad) scale(${scale})`,
      clip: `inset(${T}px ${Rr}px ${B}px ${L}px round ${rad}px)`,
    };
  }

  let byKey = false;
  addEventListener('keydown', () => { byKey = true; }, true);
  addEventListener('pointerdown', () => { byKey = false; }, true);
  let opener = null, lastFocus = null, hiddenImg = null, anims = [];
  const run = (el, kf, o) => { const a = el.animate(kf, o); anims.push(a); return a; };
  function settle() { // 途中の動きを今の見た目のまま止める
    anims.forEach(a => { try { a.commitStyles(); } catch (e) {} a.cancel(); });
    anims = [];
  }
  const hideSrc = im => { if (hiddenImg && hiddenImg !== im) hiddenImg.style.visibility = ''; hiddenImg = im; if (im) im.style.visibility = 'hidden'; };

  function open(el) {
    if (state !== 'closed') return;
    state = 'opening'; opener = el; lastFocus = document.activeElement;
    i = el._zk;
    layout(); pos = x[i];
    S.forEach(s => { s.fig.style.transform = ''; s.fig.style.opacity = ''; });
    const g = reduce.matches ? null : geom(el, i);
    const sb = innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--zm-sb', sb + 'px');
    document.documentElement.classList.add('is-zoom');
    box.hidden = false; box.style.pointerEvents = '';
    curtain.style.transform = ''; curtain.style.opacity = '';
    prime(i); full(i); render(); ui(0);
    bClose.focus({ preventScroll: true, focusVisible: byKey });
    let done;
    if (!g) {
      done = run(box, [{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
    } else {
      hideSrc(g.img);
      const fig = S[i].fig;
      run(curtain, [{ transform: `translateY(${-(H + HEM)}px)` }, { transform: 'translateY(0px)' }], { duration: 620, easing: EASE_SOFT });
      done = run(fig, [{ transform: g.t, clipPath: g.clip }, { transform: ID, clipPath: fig.style.clipPath }], { duration: 760, easing: EASE_PHOTO });
      [i - 1, i + 1].forEach(k => {
        if (!S[k]) return;
        run(S[k].fig, [{ opacity: 0, transform: `translate(${(k - i) * 90}px, 0px) rotate(0rad) scale(1)` }, { opacity: 1, transform: ID }], { duration: 700, delay: 200, easing: EASE_PHOTO, fill: 'backwards' });
      });
      [count, bClose, cap].forEach(u => run(u, [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: 260, delay: 300, easing: EASE_FAST, fill: 'backwards' }));
      [[bPrev, -1], [bNext, 1]].forEach(([b, d]) => run(b, [{ opacity: 0, transform: `translateX(${d * -10}px)` }, { opacity: 1, transform: 'none' }], { duration: 300, delay: 340, easing: EASE_FAST, fill: 'backwards' }));
    }
    done.finished.then(() => { if (state === 'opening') { anims = []; state = 'open'; } }).catch(() => {});
  }

  async function close(fromDrag) {
    if (state === 'closed' || state === 'closing') return;
    settle(); stopSpring();
    state = 'closing'; box.style.pointerEvents = 'none';
    pos = x[i]; render();
    // 戻り先: 開いた写真ならその要素、送った先なら同じ写真の要素（横の列はその写真が見える所まで裏でずらす）
    const cands = srcs[i].includes(opener) ? [opener, ...srcs[i].filter(e => e !== opener)] : srcs[i];
    const sc = scroller(cands[0]);
    if (sc) {
      const r = imgOf(cands[0]).getBoundingClientRect(), cr = sc.getBoundingClientRect();
      if (r.left < cr.left || r.right > cr.right) { sc.style.scrollSnapType = 'none'; sc.scrollLeft += r.left - cr.left - (cr.width - r.width) / 2; }
    }
    let g = null;
    if (!reduce.matches) for (const c of cands) if ((g = geom(c, i))) break;
    const fig = S[i].fig, from = fig.style.transform || ID, curOp = +getComputedStyle(curtain).opacity;
    [count, cap, bClose, bPrev, bNext].forEach(u => run(u, [{ opacity: getComputedStyle(u).opacity }, { opacity: 0 }], { duration: 140, easing: 'ease-out', fill: 'forwards' }));
    S.forEach((s, k) => { if (k !== i) run(s.fig, [{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out', fill: 'forwards' }); });
    let done;
    if (reduce.matches) {
      done = run(box, [{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease-out', fill: 'forwards' });
    } else if (g) {
      hideSrc(g.img);
      done = run(fig, [{ transform: from, clipPath: fig.style.clipPath }, { transform: g.t, clipPath: g.clip }], { duration: fromDrag ? 480 : 540, easing: EASE_BACK, fill: 'forwards' });
      run(curtain, fromDrag
        ? [{ opacity: curOp }, { opacity: 0 }]
        : [{ transform: 'translateY(0px)' }, { transform: `translateY(${-(H + HEM)}px)` }], { duration: fromDrag ? 380 : 560, delay: fromDrag ? 0 : 60, easing: fromDrag ? 'ease-out' : 'cubic-bezier(.5, 0, .25, 1)', fill: 'forwards' });
    } else { // 元の写真が画面外: その場で少し沈んで消える
      hideSrc(null);
      done = run(fig, [{ transform: from, opacity: 1 }, { transform: 'translate(0px, 36px) rotate(0rad) scale(.92)', opacity: 0 }], { duration: 360, easing: 'cubic-bezier(.4, 0, .6, 1)', fill: 'forwards' });
      run(curtain, [{ opacity: curOp }, { opacity: 0 }], { duration: 420, delay: 80, easing: 'ease-out', fill: 'forwards' });
    }
    await Promise.race([done.finished.catch(() => {}), new Promise(r => setTimeout(r, 2500))]);
    hideSrc(null);
    anims.forEach(a => a.cancel()); anims = [];
    box.hidden = true; box.style.pointerEvents = '';
    S.forEach(s => { s.fig.style.transform = ''; s.fig.style.opacity = ''; });
    curtain.style.opacity = ''; curtain.style.transform = '';
    [count, cap, bClose, bPrev, bNext].forEach(u => { u.style.opacity = ''; u.style.transform = ''; });
    if (sc) sc.style.scrollSnapType = '';
    document.documentElement.classList.remove('is-zoom');
    document.documentElement.style.removeProperty('--zm-sb');
    state = 'closed';
    // フォーカスは押した写真へ戻す。枠が見えるのはキーボードで操作していた時だけ
    (lastFocus && lastFocus !== document.body ? lastFocus : opener)?.focus?.({ preventScroll: true, focusVisible: byKey });
  }

  // 指: 横は送り、下は閉じる。上はゴムの抵抗だけ
  const rubber = (d, dim) => (1 - 1 / (Math.abs(d) * 0.55 / dim + 1)) * dim * Math.sign(d);
  let drag = null, tapBg = false;
  // 背景を軽く押したら閉じる（click で閉じる＝閉じた後のクリックが下のページに抜けない）
  box.addEventListener('click', e => { if (tapBg && !e.target.closest('button')) close(); tapBg = false; });
  box.addEventListener('pointerdown', e => {
    if (state !== 'open' || e.button !== 0 || e.target.closest('button')) return;
    stopSpring();
    drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, p0: pos, axis: null, pts: [[e.timeStamp, e.clientX, e.clientY]], onPhoto: !!e.target.closest('.zm__fig') };
    box.setPointerCapture(e.pointerId);
  });
  box.addEventListener('pointermove', e => {
    if (!drag || e.pointerId !== drag.id) return;
    const dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
    drag.pts.push([e.timeStamp, e.clientX, e.clientY]); if (drag.pts.length > 8) drag.pts.shift();
    if (!drag.axis) {
      if (Math.hypot(dx, dy) < 8) return;
      drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    }
    if (drag.axis === 'x') {
      full(i + (dx < 0 ? 1 : -1));
      const raw = drag.p0 - dx, lo = x[0], hi = x[N - 1];
      pos = raw < lo ? lo - rubber(lo - raw, W) : raw > hi ? hi + rubber(raw - hi, W) : raw;
      render();
    } else {
      const yy = dy > 0 ? dy : rubber(dy, H), p = Math.min(Math.max(yy, 0) / (H * 0.6), 1);
      S[i].fig.style.transform = `translate(${dx * 0.7}px, ${yy}px) rotate(${(dx / W) * 0.18}rad) scale(${1 - p * 0.22})`;
      curtain.style.opacity = 1 - p * 0.8;
      box.querySelector('.zm__ui').style.opacity = 1 - Math.min(p * 3, 1);
    }
  });
  const endDrag = e => {
    if (!drag || e.pointerId !== drag.id) return;
    const d = drag; drag = null;
    const p0 = d.pts[0], p1 = d.pts[d.pts.length - 1], dt = Math.max(p1[0] - p0[0], 1) / 1000;
    const vx = (p1[1] - p0[1]) / dt, vy = (p1[2] - p0[2]) / dt;
    const dx = e.clientX - d.x0, dy = e.clientY - d.y0;
    if (!d.axis) { tapBg = !d.onPhoto && e.type === 'pointerup'; return; }
    if (d.axis === 'x') {
      const v = -vx, moved = pos - x[i];
      let k = i;
      if (moved > W * 0.15 || (v > 350 && moved > 0)) k = i + 1;
      else if (moved < -W * 0.15 || (v < -350 && moved < 0)) k = i - 1;
      k = Math.max(0, Math.min(N - 1, k));
      if (k !== i) { const dir = Math.sign(k - i); i = k; full(i); ui(dir); }
      springTo(x[i], Math.max(-4000, Math.min(4000, v)));
    } else {
      const uiEl = box.querySelector('.zm__ui');
      if (dy > 110 || (vy > 600 && dy > 30)) { uiEl.style.opacity = ''; close(true); return; }
      const fig = S[i].fig, from = fig.style.transform;
      fig.style.transform = '';
      fig.animate([{ transform: from }, { transform: ID }], { duration: 460, easing: EASE_PHOTO });
      curtain.animate([{ opacity: curtain.style.opacity }, { opacity: 1 }], { duration: 300, easing: 'ease-out' });
      uiEl.animate([{ opacity: uiEl.style.opacity }, { opacity: 1 }], { duration: 300, easing: 'ease-out' });
      curtain.style.opacity = ''; uiEl.style.opacity = '';
    }
  };
  box.addEventListener('pointerup', endDrag);
  box.addEventListener('pointercancel', endDrag);
  box.addEventListener('contextmenu', e => e.preventDefault());

  // トラックパッドの横スワイプ（1 回の払いで 1 枚）。縦のホイールは背面に流さない
  let wAcc = 0, wLock = false, wTimer = 0;
  box.addEventListener('wheel', e => {
    e.preventDefault();
    if (state !== 'open') return;
    clearTimeout(wTimer); wTimer = setTimeout(() => { wAcc = 0; wLock = false; }, 180);
    if (wLock || Math.abs(e.deltaX) < Math.abs(e.deltaY)) return;
    wAcc += e.deltaX;
    if (Math.abs(wAcc) > 40) { wLock = true; go(i + Math.sign(wAcc)); }
  }, { passive: false });

  bClose.addEventListener('click', () => close());
  bPrev.addEventListener('click', () => go(i - 1));
  bNext.addEventListener('click', () => go(i + 1));
  bPrev.addEventListener('pointerenter', () => full(i - 1));
  bNext.addEventListener('pointerenter', () => full(i + 1));
  addEventListener('keydown', e => {
    if (box.hidden || state === 'closing') return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
    else if (e.key === 'Tab') { // 拡大の中だけを回る
      const f = [bClose, bPrev, bNext].filter(b => !b.disabled && b.offsetParent);
      const at = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(at + (e.shiftKey ? -1 : 1) + f.length) % f.length]?.focus();
    }
  });
  let rz = 0;
  addEventListener('resize', () => {
    if (box.hidden) return;
    cancelAnimationFrame(rz);
    rz = requestAnimationFrame(() => { if (state === 'open') { layout(); pos = x[i]; render(); } });
  });

  els.forEach(el => {
    el.style.cursor = 'zoom-in';
    el.addEventListener('click', e => { e.preventDefault(); open(el); });
    if (el.tagName !== 'BUTTON') el.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(el); } });
  });
})();
